import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

const onGetAllActiveQueue = async () => {
  const { data } = await API.get("/queues/getAllActiveQueue?queues_sorted=true");
  return data;
};

// Dipoll tiap 10 detik: antrian selesai di sisi suster, dan backend menghitung
// ulang recommended_arrival_time serta daftar antrian terlewat setiap itu terjadi.
const useGetAllActiveQueue = (options = {}) => {
  return useQuery([QUERY_KEY.GET_ALL_ACTIVE_QUEUE], onGetAllActiveQueue, {
    refetchInterval: 10000,
    ...options,
  });
};

export default useGetAllActiveQueue;
